import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { NgbModal, NgbPopover, NgbPopoverConfig, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AuthService, BaseSiteService, CmsService, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { distinctUntilChanged, filter, map, take } from "rxjs/operators";
import { CustomPdpService } from "src/app/custom-pdp/custom-pdp.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { OrderHistoryService } from '../../order-history/order-history.service';
import { CustomAddToCartService } from "../custom-add-to-cart.service";


@Component({
  selector: 'app-mini-cart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mini-cart.component.html',
  styleUrls: ['./mini-cart.component.scss'],
})
export class MiniCartComponent implements OnInit, OnDestroy {
  name = 'World';
  itemInCart = false;
  userDetails: any;
  isFlu = false;
  currentPage: any;
  standardCartDetails: any;
  influenzaCartDetails: any;
  userAccountgetData: any;
  stdCartEntries: any;
  totalquantityCart: any;
  totalquantityfluCart: any;
  fluCartDetails: any;
  fluCartEntries: any;
  productEntries: any = [];
  searchedClientList: any;
  selectedData: any;
  productFluEntries = [];
  stdCartEntry = 0;
  isEmpty = true;
  allCartDetails: any;
  stdCartDetails: any;
  public images: any;
  totalQuantity: any = [];
  totalQuantityFlu: any = [];
  quantityDisplay: any;
  quantityDisplayFlu: any;
  saveCartName: string;
  usergetDataObj: any;
  getuserData: any;
  baseUrl: string;
  cartId: any;
  isEmptyFlu = false;
  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  errorMsg: string;
  cartSavedSuccess: string;
  cartItems: any;
  @ViewChild('p1') public emptypopover: NgbPopover;
  @ViewChild('popTitleSuccess', { static: false })
  private readonly popTitleSuccess;
  @ViewChild('p2') public stdpopover: NgbPopover;
  @ViewChild('t') public tooltip: NgbTooltip;
  @ViewChild('p4') public flupopover: NgbPopover;
  @ViewChild('s1') public savedpopover: NgbPopover;
  @ViewChild('s3') public saveorderpopover: NgbPopover;
  @ViewChild('c1') public sessionCartPopover: NgbPopover;
  @ViewChild('p5') public successLogoutPopover: NgbPopover;
  updatedStdSub: Subscription;
  plpMiniCartSub: Subscription;
  pdpMiniCartSub: Subscription;
  updateSessionSub: Subscription;
  restoreSub: Subscription;
  saveOrderSub: Subscription;
  orderHistorySub: Subscription;
  allCartItemsSub: Subscription;
  userAccountSub: Subscription;
  userAccountDetailsSub: Subscription;
  cartItemsSub: Subscription;
  invalidCartSub: Subscription;
  saveCartSub: Subscription;
  userAccSub: Subscription;
  authCheck: Subscription;
  orderSubTotal: any;
  isSingleLocation = true;
  baseSiteId: any;
  fluJourneyPage: boolean = false;
  punchOutKey: boolean;
  getUserSub: Subscription;
  userSub: Subscription;
  userIdDetails: any;
  isAsmEnabled: boolean;
  constructor(
    private readonly user: UserAccountFacade,
    private readonly addToCart: CustomAddToCartService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: RoutingService,
    private readonly pageDate: CmsService,
    private readonly config: NgbPopoverConfig,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    private readonly pdpService: CustomPdpService,
    private readonly checkoutService: CheckoutService,
    private readonly orderHistoryService: OrderHistoryService,
    private readonly sharedService: SharedService,
    private readonly modalService: NgbModal,
    private readonly authService: AuthService,
    private readonly locService: LoactionStripService,
    private baseSiteService: BaseSiteService,
    private router: Router,
    private profService: CustomProfileAndPreferencesService
  ) {
    config.autoClose = 'outside';
    config.closeDelay = 2000;
    config.openDelay = 1000;
  }
  tooltipToggle() {
    this.tooltip.open();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideLogin();

      }
    });

    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
      this.cdr.detectChanges();
    }

    if (localStorage.getItem('asm_enabled') != null) {
      this.isAsmEnabled = true;
      this.cdr.detectChanges();
    }

    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.authCheck = this.authService.isUserLoggedIn().subscribe((res) => {
          if (!res) {
            // this.allCartDetails = [];  //this should not be done
            this.authCheck?.unsubscribe();
            this.successLogoutPopover.open();
            setTimeout(() => this.successLogoutPopover.close(), 2500);
          }
        });
      }
    });
    this.itemInCart = true;
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.updatedStdSub = this.checkoutService.updatedStdOrderDetails$.subscribe(
      (res) => {
        if (res
          && (this.currentPage != 'fluCategoryPage' &&
            this.currentPage != 'fluStsLandingPage' &&
            this.currentPage != 'FluverifypaymentPage' &&
            this.currentPage != 'orderConfirmationFluPage' &&
            this.currentPage != 'fluseasonreservationpage')) {//To avoid making get cart calls without stdcart false during flu journey as asked by Manoj
          this.addToCart.getAllCarts(this.userAccountgetData?.uid);
          //this.plpService.getCarts(this.userDetails?.userName);
          this.plpService.getCarts(this.userDetails?.uid);
          this.addToCart.cartItems.next(false);
        }
      }
    );
    this.plpMiniCartSub = this.plpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.pdpMiniCartSub = this.pdpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.updateSessionSub = this.addToCart
      .getUpdateSessionCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.restoreSub = this.addToCart.getRestoredCart().subscribe((res) => {
      if (res) {
        this.getCartDetails(res);
        //this.route.goByUrl('/cart');
      }
    });
    this.saveOrderSub = this.addToCart
      .getUpdateSavedOrder()
      .subscribe((res) => {
        if (res) {
          this.cartSavedSuccess = res?.savedCartData?.name;
          this.savedpopover.open();
          setTimeout(() => this.savedpopover.close(), 2500);
        }
      });
    this.orderHistorySub = this.orderHistoryService
      .getSavedOrderName()
      .subscribe((res) => {
        if (res) {
          this.cartSavedSuccess = res?.savedCartData?.name;
          this.savedpopover.open();
          setTimeout(() => this.savedpopover.close(), 2500);
        }
      });

    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      this.currentPage = res?.pageId;
      if (res) {
        const sessionCartPopover = res?.slots?.MiniCart;
        //check added for flicker issue
        const registerKey = sessionStorage.getItem('register');
        if (Object.keys(sessionCartPopover).length === 0 && registerKey == null) {
          sessionStorage.clear();
        }
      }
      if (this.currentPage === 'fluCategoryPage' ||
        this.currentPage === 'fluStsLandingPage' ||
        this.currentPage === 'FluverifypaymentPage' ||
        this.currentPage === 'orderConfirmationFluPage' ||
        this.currentPage === 'fluseasonreservationpage') {
        this.fluJourneyPage = true;
        this.cdr.detectChanges();
      }
      else {
        this.fluJourneyPage = false;
        this.cdr.detectChanges();
      }

      if (
        this.currentPage === 'fluseasonreservationpage' ||
        this.currentPage === 'FluSeasonProductListPage' ||
        this.currentPage === 'fluseasonviewcartpage' ||
        this.currentPage === 'fluseasonviewpaymentpage' ||
        this.currentPage === 'flureservationconfirmationpage' ||
        this.currentPage === 'flureservationoverviewpage'
      ) {
        this.isFlu = true;
      } else {
        this.isFlu = false;
      }
      this.cdr.detectChanges();
    }, errors => {
      this.fluJourneyPage = false;  //in case of any error just keeping default value
    });
    this.userAccSub = this.authService.isUserLoggedIn().pipe(distinctUntilChanged()).subscribe((res) => {
      // this.userSub = 
      //$('#loginRegisterButton').css('display', 'none');
      const miniCart = document.getElementById(`miniCart`) as HTMLElement;
      this.profService._userAccountData.pipe(filter(res => !!res), map(({ defaultB2BUnit }) => ({ uid: defaultB2BUnit.uid })), take(1)).subscribe((res2) => {
        // this.userSub?.unsubscribe();
        if (res && res2) {
          //if (res) {

          setTimeout(() => {
            if (
              this.sharedService.miniCartPopup === true &&
              this.allCartDetails &&
              this.allCartDetails?.length > 0
            ) {

              $('#cartNotificationPopup').show();
            } else {

              $('#cartNotificationPopup').hide();
            }
          }, 4000);
          this.userDetails = this.userAccountgetData = { uid: JSON.parse(localStorage.getItem('userId')) };
          $('#loginRegisterButton').css('display', 'none');
          miniCart.classList.remove('not-visible');
          this.cdr.detectChanges();
          this.getUserAccountData(this.userAccountgetData.uid);
          //To avoid making get cart calls without stdcart false during flu journey as asked by Manoj
          if (this.currentPage != 'fluCategoryPage' &&
            this.currentPage != 'fluStsLandingPage' &&
            this.currentPage != 'FluverifypaymentPage' &&
            this.currentPage != 'orderConfirmationFluPage' &&
            this.currentPage != 'fluseasonreservationpage') {
            this.addToCart.getAllCarts(this.userAccountgetData?.uid);
            this.plpService.getCarts(this.userAccountgetData?.uid);
          }
          this.allCartItemsSub = this.addToCart.allCartItems$.subscribe(
            (res1) => {
              if (res1) {
                this.cartItems = res1?.carts;

                this.cartItems = this.cartItems?.filter(
                  (item) => item?.saveTime === undefined
                );
                this.cartItems = !!this.cartItems?.length && this.cartItems[this.cartItems?.length - 1];
                if (this.cartItems === undefined) {
                  $('#cartNotificationPopup').hide();
                  this.isEmpty = true;
                  this.quantityDisplay = '';
                  this.cdr.detectChanges();
                  this.addToCart.cartItems.next(false);
                  this.cdr.detectChanges();
                }
                this.cartId = this.cartItems?.code;
                this.getCartDetails(this.cartId);
              }
            }
          );

        }
      });
      if (!res) {
        $('#loginRegisterButton').css('display', 'flex');
        miniCart.classList.add('not-visible');
        $('#cartNotificationPopup').hide();
        sessionStorage.removeItem('sessionCartPopover');
        this.addToCart.deleteCartCache();
        this.allCartItemsSub?.unsubscribe();
      }
      this.cdr.detectChanges();
    });



    this.locService.emitSelectedLocs.subscribe((res) => {
      if (res) {
        this.isSingleLocation = res && res.length === 1 ? true : false;
      }
    });
  }

  getUserAccountData(userId): void {
    this.addToCart.getUserAccountDataFromDb(userId);
    this.userAccountSub = this.addToCart.userAccountData.subscribe(
      (userData) => {
        if (
          userData.res != null &&
          userData.res !== undefined &&
          userData.res?.length !== 0
        ) {
          this.usergetDataObj = userData.res.defaultB2BUnit;
          const accountId = this.usergetDataObj.uid;
          this.addToCart.getUserAccountDetailsDataFromDb(userId, accountId);
          this.userAccountDetailsSub =
            this.addToCart.userAccountDetails.subscribe((userDataget) => {
              if (userDataget) {
                this.getuserData = userDataget.res.shippingAddresses;
                this.searchedClientList = userDataget.res.shippingAddresses;
                //if (this.getuserData) {
                // this.saveCartName =
                //this.selectedData?.companyName?.slice(0,30);
                //this.selectedData?.name?.slice(0, 30);
                //}
              }
            });
          this.cdr.detectChanges();
        }
      }
    );
  }
  getCartDetails(cartId): void {
    //To avoid making get cart calls without stdcart false during flu journey as asked by Manoj
    if (this.currentPage != 'fluCategoryPage' &&
      this.currentPage != 'fluStsLandingPage' &&
      this.currentPage != 'FluverifypaymentPage' &&
      this.currentPage != 'orderConfirmationFluPage' &&
      this.currentPage != 'fluseasonreservationpage') {
      this.addToCart.getCarts(cartId, this.userAccountgetData?.uid);
      this.cartItemsSub = this.addToCart.cartItems$.subscribe((cartData: any) => {
        if (cartData) {
          this.cartDataMapping(cartData);
        }
      });
    }
  }

  navigatetoProduct(code) {
    this.route.go(`/product/${code}/${code}`, {
      queryParams: {
        variantSelected: true
      }
    });
  }
  cartDataMapping(data): void {
    this.productEntries = [];
    this.productFluEntries = [];
    this.cartId = data?.code;
    this.allCartDetails = [];
    this.allCartDetails = data?.childCarts;
    this.stdCartEntry = data.totalItems;

    if (this.allCartDetails) {
      this.stdCartDetails = this.allCartDetails;
      // .filter(
      //   (item) => item.cartType === 'STANDARD'
      // );
      this.standardCartDetails = Object.assign({}, ...this.stdCartDetails);
      if (this.stdCartDetails.length <= 0) {
        this.isEmpty = true;
      } else if (this.stdCartDetails.length > 0) {
        this.isEmpty = false;
      }
      if (this.standardCartDetails?.shipToParty) {
        // this.selectedData = this.standardCartDetails?.shipToParty?.shippingAddresses.filter((item) => item.unitID === this.standardCartDetails.shipToParty.uid);
        //this.selectedData = _.first(this.selectedData);
        this.selectedData = this.standardCartDetails?.shipToParty;
      }
      //this.selectedData = this.standardCartDetails?.shipToLoc_name;
      this.orderSubTotal = 0;
      let totalUnitAll = 0;
      for (const cartDetails of this.stdCartDetails) {
        this.stdCartEntries = cartDetails;
        let tempEntries = [];
        // this.orderSubTotal += cartDetails?.totalPrice?.value;
        if (!cartDetails?.hidePriceForProduct && !cartDetails?.hidePriceForTotals) {
          this.orderSubTotal += cartDetails?.subTotal?.value;
        } else {
          this.orderSubTotal = '$--'
        }
        this.cdr.detectChanges();
        for (let entries of cartDetails.entries) {
          //const imagesFormat = _.clone(_.findWhere(entries.product?.images, { format: 'cartIcon' }));
          const imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'thumbnail' })
          );
          if (imagesFormat) {
            imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
          }
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          tempEntries.push(entries);
          const quantity = [];
          for (const total of this.stdCartEntries?.entries) {
            quantity.push(total.quantity);
            this.totalquantityCart = quantity;
          }
          this.totalQuantity = this.totalquantityCart.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );
          // if (this.totalQuantity > 99) {
          //   this.quantityDisplay = '99+';
          // } else {
          //   this.quantityDisplay = this.totalQuantity;
          // }

          if (!sessionStorage.getItem('sessionCartPopover')) {
            if (this.sessionCartPopover) {
              this.sessionCartPopover.open();
              setTimeout(() => this.sessionCartPopover.close(), 2500);
            }
            sessionStorage.setItem('sessionCartPopover', 'true');
          }
        }
        cartDetails['totalUnit'] = this.totalQuantity;
        totalUnitAll = totalUnitAll + Number(this.totalQuantity);
        cartDetails.entries = [...tempEntries];
        this.productEntries.push(cartDetails);
        this.cdr.detectChanges();
      }
      this.quantityDisplay = totalUnitAll > 99 ? '99+' : totalUnitAll;

      if (this.quantityDisplay === 0) {
        $('#cartNotificationPopup').hide();
        this.cdr.detectChanges();
      }
      this.fluCartDetails = this.allCartDetails.filter(
        (item) => item.cartType === 'INFLUENZA'
      );

      this.influenzaCartDetails = Object.assign({}, ...this.fluCartDetails);
      this.isEmptyFlu =
        this.influenzaCartDetails?.entries?.length <= 0 ||
          this.fluCartDetails?.length <= 0
          ? true
          : false;
      this.quantityDisplayFlu = '';
      for (const cartDetails of this.fluCartDetails) {
        this.fluCartEntries = cartDetails;
        for (let entries of cartDetails.entries) {
          const imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'cartIcon' })
          );
          if (imagesFormat) {
            imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
          }
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          this.productFluEntries.push(entries);
          const quantity = [];
          for (const total of this.fluCartEntries?.entries) {
            quantity.push(total.quantity);
            this.totalquantityfluCart = quantity;
          }
          this.totalQuantityFlu = this.totalquantityfluCart.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );
          if (this.totalQuantityFlu > 99) {
            this.quantityDisplayFlu = '99+';
          } else {
            this.quantityDisplayFlu = this.totalQuantityFlu;
          }
        }
        this.cdr.detectChanges();
      }
      this.saveCartName =
        this.productEntries.length >= 1
          ? this.productEntries[0]?.shipToLoc_name
          : '';
    }
    this.cdr.detectChanges();
  }
  toggleWithGreeting(popover) {
    this.route.goByUrl('/cart');
    // if (this.isFlu) {
    //   this.route.goByUrl('/influenza/cart');
    // } else {
    //   this.route.goByUrl('/cart');
    // }
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';
    //this.saveCartName = this.selectedData?.companyName?.slice(0,30);
    // this.saveCartName = this.selectedData?.name?.slice(0, 30);
  }
  navigateToPdp() {
    this.emptypopover.close();
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  saveOrder(): void {
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId);
      this.invalidCartSub = this.addToCart.invalidCartName$.subscribe((res) => {
        if (res) {
          for (const error of res?.error?.errors) {
            this.errorMsg = error?.message;
          }
        }
      });
      this.saveCartSub = this.addToCart.saveCartSuccess$.subscribe((res) => {
        if (res) {
          this.stdpopover.close();
        }
      });
    } else {
      if (this.saveCartName) {
        this.errorMsg = 'Save cart name is not valid.';
      } else {
        this.errorMsg = 'The cart name cannot be blank.';
      }
    }
  }
  clearChildCart(): void {
    this.addToCart.clearCart(this.cartId, this.currentPage);
    if (localStorage.hasOwnProperty('futureshipModalOpened'))
      this.sharedService.removeLocalStorage('futureshipModalOpened');
  } // clear cart
  navigateToCart() {
    this.stdpopover.close();
    this.route.goByUrl('/cart');
  }

  navigateToSavedOrder() {
    this.emptypopover.close();
    this.route.goByUrl('/cart/save');
  }
  navigateTominiSavedOrder() {
    this.route.goByUrl('/cart/save');
  }
  navigateToFlu() {
    this.emptypopover.close();
    this.route.goByUrl('/influenza/dashboard');
  }
  navigateToNotification() {
    this.route.goByUrl('/messageHistoryPage');
  }
  navigateToFlufromCart() {
    this.flupopover.close();
    this.route.goByUrl('/influenza/cart');
  }
  naviToCartModal() {
    $('#cartNotificationPopup').hide();
    this.sharedService.miniCartPopup = false;
    this.cdr.detectChanges();
    this.route.goByUrl('/cart');
  }
  naviToPdpModal() {
    this.sharedService.miniCartPopup = false;
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  clearCartModal(): void {
    this.sharedService.miniCartPopup = false;
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
    this.addToCart.clearCart(this.cartId);
  }
  goToLogin() {
    this.route.goByUrl('/login');
  }
  goToRegister() {
    this.route.goByUrl('/register');
    $('.headerLoginSection').hide();
  }
  closepop() {
    if (this.stdpopover) {
      this.stdpopover.close();
    }
    if (this.emptypopover) {
      this.emptypopover.close();
    }
    if (this.flupopover) {
      this.flupopover.close();
    }
    this.errorMsg = '';
    //this.saveCartName = this.selectedData?.companyName?.slice(0,30);
    // this.saveCartName = this.selectedData?.name?.slice(0, 30);
  }
  omit_special_char(event) {
    this.errorMsg = '';
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  ngOnDestroy() {
    this.updatedStdSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.pdpMiniCartSub?.unsubscribe();
    this.updateSessionSub?.unsubscribe();
    this.restoreSub?.unsubscribe();
    this.saveOrderSub?.unsubscribe();
    this.orderHistorySub?.unsubscribe();
    this.allCartItemsSub?.unsubscribe();
    this.userAccountSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.invalidCartSub?.unsubscribe();
    this.saveCartSub?.unsubscribe();
    this.userAccSub?.unsubscribe();

  }
  closePopup() {
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
  }
  stdFluDesc(productentry) {
    // return (productentry?.product?.variantOptions.length > 0 && productentry?.product?.variantOptions[0]?.flu &&
    //   productentry?.product?.variantOptions[0]?.shipNow == 'ON') || (productentry?.product?.variantOptions.length == 0 &&
    //     productentry?.product?.flu && productentry?.product?.shipNow == 'ON') ? 'Influenza Vaccine' : productentry?.product?.description
    return productentry?.product?.description;
  }

  displayLogin = false;
  showLogin() {
    $('.headerLoginSection').show();
    window.scroll(0, 0);
  }

  hideLogin() {
    $('.headerLoginSection').hide();
  }
}